
import { Vue, Component, Prop } from "vue-property-decorator";
import Datepicker from "vuejs-datepicker";
import PlusIcon from '@/components/icons/PlusIcon.vue';
import CalendarIcon from '@/components/icons/CalendarIcon.vue';

@Component({
  components: {
    Datepicker,
    PlusIcon,
    CalendarIcon
  },
})
export default class FormDatepicker extends Vue {
  @Prop({ type:[Date, String], default: null }) value!: Date | string | null;
  @Prop({ type: Date, default: undefined }) openDate?: Date;
  @Prop({ type: Boolean, default: false }) readonly invalid!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: "YYYY-MM-DD" }) readonly placeholder!: string;
  @Prop({ type: String, default: "" }) readonly calendarClass!: string;
  @Prop({ type: Array, default: () => [] }) readonly highlighted!: [];
  @Prop({ type: Object, default: () => {} }) readonly disabledDates!: object;
   @Prop({ type: String, default: "datePicker" }) readonly id?: string;
  @Prop({ type: String, default: "" }) readonly heightClass?: string;
  @Prop({ type: Boolean, default: undefined }) readonly customInputClass?: Boolean;
  @Prop({ type: Boolean, default: false }) readonly isCalenderIcon?: Boolean;

  $moment: any;

  highlightToday: Date = new Date();

  get classObject(): Object {
    return {
      "h-input": !this.heightClass,
      "rounded-md" : !this.customInputClass,
      "rounded-lg" : this.customInputClass,
      "bg-input-disabled border-gray-200": this.disabled,
      "bg-inherit": !this.disabled,
      "rounded-custom": this.heightClass,
      "w-full py-2 px-3 text-sm border focus:outline-none focus:border-primary": !this.invalid,
      "w-full py-2 px-3 text-sm border border-red-300 placeholder-red-300 focus:border-red-300 text-red-800 outline-none": this.invalid,
    };
  }

  get highlightedDates(): Object {
    return {
      dates: [this.highlightToday, ...this.highlighted],
    };
  }

  updateValue(date: any): void {
    this.$emit("input", date);
  }
}
